import { render, staticRenderFns } from "./campaign-save-dialog.vue?vue&type=template&id=30ab529b&scoped=true"
import script from "./campaign-save-dialog.vue?vue&type=script&lang=js"
export * from "./campaign-save-dialog.vue?vue&type=script&lang=js"
import style0 from "./campaign-save-dialog.vue?vue&type=style&index=0&id=30ab529b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ab529b",
  null
  
)

export default component.exports